export class ClaimDTO {
  transactionId: number;
  transactionNo: string;
  transactionDate: string;
  transactionType: string;
  processingClass: string;
  authorisationNo: string;
  inHospitalClaim: string;
  planCode: number;
  providerNumber: string; // a.k.a. practice number for PP
  prescribingProviderNumber: string;
  referringProviderNumber: string;
  treatingProviderNumber: string;
  assistantProviderNumber: string;
  groupPracticeNumber: string;
  providerSubmittedInd: string;
  receiptAmount: number;
  referenceNumber: string;
  invoiceNumber: string;
  invoiceDate: string;
  startDate: string;
  endDate: string;
  sender: string;
  note: string;
  caseId: number;
  productId: number;
  providerId: number;
  prescribingProviderId: number;
  referringProviderId: number;
  treatingProviderId: number;
  assistantProviderId: number;
  groupPracticeId: number;
  consentIndicator: number;
  consentReason: string;
  claimOverrideIndicator1: number;
}
